module.exports = __webpack_public_path__ + "img/btn_product_03_play@2x.299c4dd4.png";